module.exports = __webpack_public_path__ + "img/activate-employee-bg.f59937ce.png";